export default __webpack_public_path__ + "static/media/drone-blue.6a1a2b3a.png";